<template>
  <div class="send-us" @click="goToChatTab">
    <div class="static-wrapper">
      <div 
        class="chat-icon-wrapper"
        :style="{ backgroundColor: widgetColor }"
      >
        <img :src="chatIcon" alt="Chat Icon" class="chat-icon"/>
        <img :src="lineIcon" alt="Line Icon" class="line-icon-1"/>
        <img :src="lineIcon" alt="Line Icon" class="line-icon-2"/>
      </div>
      <div class="send-us-wrapper">
        <div class="send-us-text-wrapper">
          {{ isOnline ? $t('SEND_US_MESSAGE') : $t('SEND_US_MAIL') }}
        </div>
        <div class="online-text-wrapper">
          {{ isOnline ? $t('TEAM_AVAILABILITY.ONLINE') : $t('TEAM_AVAILABILITY.OFFLINE') }}
        </div>
      </div>
    </div>
    <div class="available-agents-wrapper">
      <div v-if="isOnline" class="available-agents-avtar-wrapper">
        <available-agents v-if="availableAgents" :agents="availableAgents" />
        <div v-if="availableAgents.length === 0" class="bot-icon-wrapper">
          <img :src="this.hiverConfig.bot_icon" alt="Bot Icon" />
        </div>
      </div>
      <div class="side-arrow-image">
        <img :src="sideArrowIcon" alt="side arrow" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import availabilityMixin from 'widget/mixins/availability';
import configMixin from '../mixins/configMixin';
import AvailableAgents from 'widget/components/AvailableAgents.vue';
import chatIcon from '../assets/images/chatIcon.svg';
import lineIcon from '../assets/images/lineIcon.svg';
import sideArrowIcon from '../assets/images/sideArrowIcon.svg';

export default {
  components: {
    AvailableAgents,
  },
  mixins: [availabilityMixin, configMixin],
  data() {
    return {
        chatIcon,
        lineIcon,
        sideArrowIcon,
    };
  },
  props: {
    chatTabProps: {
      type: Object,
      default: () => ({}),
    },
    isOnline: {
      type: Boolean,
    }
  },
  computed: {
    ...mapGetters({
      hiverConfig: 'hiverConfig/getHiverConfig',
      availableAgents: 'agent/availableAgents',
      widgetColor: 'appConfig/getWidgetColor',
    }),
  },
  methods: {
    ...mapActions('agent', ['fetchAvailableAgents']),
    ...mapActions('hiverConfig', ['fetchHiverConfig']),
    goToChatTab() {
      window.bus.$emit('chat-tab-clicked');
      this.$router.push({
        path: '/chat',
        query: {
          ...this.chatTabProps,
        }
      });
    },    
  },
};
</script>

<style scoped lang="scss">
@import "~widget/assets/scss/_widgetHome.scss";
</style>